import { jsx as _jsx } from "react/jsx-runtime";
import { ErrorPage } from '@assetmark/ui-components';
import { DefaultLayout } from '../layouts/Default';
import styles from './ErrorPage.module.scss';
/**
 * Not found is a special page that is not wrapped in the default layout,
 * as it is not a children route.
 *
 * @constructor
 */
export const NotFoundPage = () => (_jsx(DefaultLayout, { children: _jsx(ErrorPage, { className: styles.page, message: "Not Found" }) }));
